import styled from 'styled-components'

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 50%;
    height: 100%;
    font-size: 25px;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1.4rem 0 1.4rem;
`

export const ContainerItem = styled.div`
    display: flex;
    width: 100%;
    height: 8vh;
    border-bottom: 1px solid #f0f0f0;
`

export const ContainerLabel = styled(FlexContainer)`
    padding-left: 1.8rem;
    padding-right: .2rem;
`

export const ContainerValue = styled(FlexContainer)`
    font-weight: bold;
    padding-right: 1.8rem;
    padding-left: .2rem;
`
